import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { Reveal, EASE } from "@/components/Reveal";
import { INSTAGRAM_GRID, BRAND } from "@/data/site";

export function InstagramSection() {
  return (
    <section className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32" data-testid="instagram">
      <Reveal className="mb-12 text-center">
        <p className="eyebrow text-gold">As Seen On You</p>
        <h2 className="mt-4 font-serif text-4xl font-light leading-tight tracking-tight text-ink md:text-6xl">
          Follow the Noora Glow
        </h2>
        <a
          href="https://instagram.com"
          target="_blank"
          rel="noreferrer"
          className="mt-5 inline-flex items-center gap-2 eyebrow link-underline text-ink/70"
          data-testid="instagram-handle"
        >
          <Instagram size={15} strokeWidth={1.5} /> {BRAND.handle}
        </a>
      </Reveal>

      <div className="grid grid-cols-2 gap-2 md:grid-cols-6 md:gap-3">
        {INSTAGRAM_GRID.map((src, i) => (
          <motion.a
            key={i}
            href="https://instagram.com"
            target="_blank"
            rel="noreferrer"
            initial={{ opacity: 0, scale: 0.94 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, ease: EASE, delay: (i % 6) * 0.05 }}
            className="group relative aspect-square overflow-hidden rounded-xl"
            data-testid={`instagram-tile-${i}`}
          >
            <img
              src={src}
              alt="Noora on Instagram"
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
            />
            <div className="absolute inset-0 grid place-items-center bg-ink/0 opacity-0 transition-all duration-400 group-hover:bg-ink/30 group-hover:opacity-100">
              <Instagram size={22} strokeWidth={1.5} className="text-ivory" />
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
